export const aboutData = {
    title: "Who I am",
    description1: "My name's Rijon. I'm a web designer and developer.",
    description2: "I am a Full Stack Web Developer having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks. I am passionate about finding solutions and helping others.",
    image: 2
}